import { X } from 'lucide-react'
import TestOpsGenie from './testOpsGenie'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RiFullscreenLine, RiMenuFold2Line } from 'react-icons/ri'
import IconButton from '../../elements/iconButton'
import TestOpsGenieHistory from './history'
import ChatToExperiment from './chatToExperiment.model'
import { trackEvent } from '../../_common/functions'
import insightCopilotLogo from '../../assets/coopilot-insight-logo.png'
import { Link } from 'react-router-dom'
import { INSIGHT_COPILOT_PROJECT_KEYS } from '../../_config'

interface Props {
    onClose: () => void
}

const TestOpsGenieModal: React.FC<Props> = ({ onClose }) => {
    const { t } = useTranslation()
    const [fullscreen, setFullscreen] = useState<boolean>(sessionStorage.getItem('testOpsGenieModelView') === 'fullscreen')
    const [historyDrawer, setHistoryDrawer] = useState<boolean>(false)
    const [TOKEN, setTOKEN] = useState<string | null>(null)
    const [chatModel, setChatModel] = useState<'experiment' | 'insight'>(sessionStorage.getItem('testOpsGenieModel') === 'insight' ? 'insight' : 'experiment')
    const [experimentChatKey, setExperimentChatKey] = useState(0)
    const [activeSessionId, setActiveSessionId] = useState<string | null>(null)
    const [leftPannelCollapsed, setLeftPannelCollapsed] = useState(false)
    const chattoExperimentRef: any = useRef()

    const chatRef: any = useRef()

    const openHistory = () => {
        setHistoryDrawer(!historyDrawer)
    }
    const toggleFullscreen = () => {
        trackEvent('ai_fullscreen_toggled', { fullscreen: !fullscreen })
        sessionStorage.setItem('testOpsGenieModelView', fullscreen ? 'popup' : 'fullscreen')
        setFullscreen(!fullscreen)
    }

    const handleNewExperimentChat = () => {
        chattoExperimentRef?.current?.createNewSession?.()
        setActiveSessionId(null)
        //setExperimentChatKey((prev) => prev + 1)
        setHistoryDrawer(false)
    }

    const handleLoadExperimentSession = (sessionId: string) => {
        setActiveSessionId(sessionId)
        setExperimentChatKey((prev) => prev + 1)
        setHistoryDrawer(false)
    }

    useEffect(() => {
        sessionStorage.setItem('testOpsGenieModel', chatModel)
    }, [chatModel])

    let historyPanelWidthClass = 'w-full'
    if (fullscreen) {
        historyPanelWidthClass = leftPannelCollapsed ? 'w-[3.5rem] border-r border-[#0000001A]' : 'w-[22rem] border-r border-[#0000001A]'
    }

    let fullscreenClass = 'bottom-6 right-6 w-[1000px] max-w-[95vw] h-[90vh] rounded-2xl shadow-2xl border border-gray-100 '
    if (fullscreen) {
        fullscreenClass = leftPannelCollapsed ? 'top-0 bottom-0 left-0 right-0 pl-[3.5rem]' : 'top-0 bottom-0 left-0 right-0 pl-[22rem]'
    }

    return (
        <div
            className={`
            fixed font-sans overflow-hidden  z-50  flex flex-col bg-white 
            ${fullscreenClass}
        `}
        >
            <div
                className={`
                absolute top-0 left-0  h-full  p-3 transition-all duration-250 ease-in-out z-10 
                ${historyDrawer || fullscreen ? 'translate-x-[0]' : 'translate-x-[-100%]'}
                ${historyPanelWidthClass}
                ${leftPannelCollapsed ? 'bg-slate-100' : 'bg-white'} 
            `}
            >
                {(TOKEN || chatModel === 'experiment') && (
                    <TestOpsGenieHistory
                        close={openHistory}
                        fullscreen={fullscreen}
                        open={historyDrawer}
                        token={TOKEN}
                        chatModel={chatModel}
                        onNewExperimentChat={handleNewExperimentChat}
                        onLoadExperimentSession={handleLoadExperimentSession}
                        activeSessionId={activeSessionId}
                        leftPannelCollapsed={leftPannelCollapsed}
                        setLeftPannelCollapsed={setLeftPannelCollapsed}
                        setConversation={(id: any) => {
                            setHistoryDrawer(false)
                            chatRef?.current?.setConversation(id)
                        }}
                        projectKey={INSIGHT_COPILOT_PROJECT_KEYS.INSIGHT}
                    />
                )}
            </div>

            <div className={`flex justify-between items-center px-6 py-4 border-b border-gray-200`}>
                <h2 className="text-lg font-semibold text-gray-900">
                    <span className="relative"></span>
                </h2>
                <div className="flex rounded-[1.667rem] border border-[#323232] relative">
                    <button
                        type="button"
                        className={`m-[2px] flex h-[1.5rem]  rounded-[0.708rem] text-[0.667rem] leading-[1.5rem] px-2 ${chatModel === 'experiment' ? 'bg-[#1D1D1D] text-[#CDCDCD]' : ''}`}
                        onClick={() => {
                            trackEvent('ai_mode_switched', { mode: 'experiment' })
                            setChatModel('experiment')
                        }}
                    >
                        {t('Chat to Experiment')}
                    </button>
                    <button type="button" className={`m-[2px] flex h-[1.5rem]  rounded-[0.708rem] text-[0.667rem] leading-[1.5rem] px-2 ${chatModel === 'insight' ? 'bg-[#1D1D1D] text-[#CDCDCD]' : ''}`} onClick={() => setChatModel('insight')}>
                        {t('Insight Generation')}
                    </button>
                </div>
                <div className="flex gap-3 items-center relative">
                    {chatModel === 'insight' && (
                        <Link to={`https://docs.insights-copilot.ab-inbev.com/what-is-ic`} target="_blank" className="absolute -left-[6.1rem] bottom-[0.1rem]">
                            <img src={insightCopilotLogo} alt="Coopilot Insight Logo" className="w-[6rem] !max-w-max" />
                        </Link>
                    )}
                    {!fullscreen && (
                        <IconButton
                            icon={<RiMenuFold2Line className="text-[1rem]" />}
                            onClick={() => {
                                trackEvent('ai_history_drawer_toggled', { open: !historyDrawer })
                                openHistory()
                            }}
                        />
                    )}

                    <IconButton icon={<RiFullscreenLine className="text-[1rem]" />} onClick={toggleFullscreen} />

                    {/*<button type="button"
                        className='p-1 rounded-md'
                        onClick={openHistory}>
                        <RiFullscreenLine className='text-[1.2rem]' />
                        <RiFullscreenExitLine className='text-[1.2rem]' /> 
                    </button> */}

                    <IconButton
                        icon={<X className="w-5 h-5 text-gray-600" />}
                        onClick={() => {
                            trackEvent('ai_modal_closed', { source: 'x_button' })
                            onClose()
                        }}
                    />
                </div>
            </div>
            {chatModel === 'experiment' && <ChatToExperiment _ref={chattoExperimentRef} key={experimentChatKey} initialSessionId={activeSessionId} />}
            {chatModel === 'insight' && <TestOpsGenie setToken={setTOKEN} _ref={chatRef} projectKey={INSIGHT_COPILOT_PROJECT_KEYS.INSIGHT} />}
        </div>
    )
}

export default TestOpsGenieModal
